import React from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { createConfiguration } from '../../../../Store/Slices/Finance/Configuration/configuration.thunk';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PayrollSaveModel({ closeConfigModel, data, configType }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { t } = useTranslation("prtFinance")
  const handleSave = () => {
    form
      .validateFields()
      .then(values => {
        let allData = { configData: { ...data, ...values }, ...values,title:'payroll', configType:'payroll' }
        dispatch(createConfiguration({ data: allData, navigate }))
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    closeConfigModel()
  };

  return (
    <div>
        {/* Details section */}
        <div className="mt-4">
          <div>• {t("Save repeated form info in finance config.")}</div>
          <div>• {t("No need to retype the same data again.")} </div>
          <div>• {t("Load and apply it directly when needed.")}</div>
        </div>
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          label={t("Description")}
          name="description"
          rules={[{ required: true, message: t('Please input the description!') }]}
        >
          <Input.TextArea rows={4} placeholder={t("Enter Description")} />
        </Form.Item>

        <Form.Item>
          <div className="flex gap-4">
            <button className='btn-gradient text-white' onClick={handleSave}>
              {t("Save")}
            </button>
            <Button className='rounded-xl' onClick={handleCancel}>
              {t("Cancel")}
            </Button>
          </div>
        </Form.Item>

        
      </Form>
    </div>
  );
}
